/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './clinical-dictionary-type.reducer';

export const ClinicalDictionaryTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const clinicalDictionaryTypeEntity = useAppSelector(state => state.clinicalDictionaryType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="clinicalDictionaryTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.detail.title">ClinicalDictionaryType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.id">Id</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.id}</dd>
          <dt>
            <span id="entryId">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.entryId">Entry Id</Translate>
            </span>
            <UncontrolledTooltip target="entryId">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.help.entryId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.entryId}</dd>
          <dt>
            <span id="dictType">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.dictType">Dict Type</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.dictType}</dd>
          <dt>
            <span id="especiality">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.especiality">Especiality</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.especiality}</dd>
          <dt>
            <span id="dictDescription">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.dictDescription">Dict Description</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.dictDescription}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.createdBy}</dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.createDate}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.lastUpdated}</dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.lastModifiedBy}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.active">Active</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{clinicalDictionaryTypeEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/clinical-dictionary-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/clinical-dictionary-type/${clinicalDictionaryTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ClinicalDictionaryTypeDetail;
